var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 42,
    width: 10,
    height: 6,
    fill: "#4285F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 48,
    width: 10,
    height: 13,
    fill: "#00B42A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 17,
    width: 10,
    height: 27,
    fill: "#4285F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 44,
    width: 10,
    height: 17,
    fill: "#00B42A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 29,
    width: 10,
    height: 13,
    fill: "#4285F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 42,
    width: 10,
    height: 19,
    fill: "#00B42A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.0eae6e042c1852683f08003e2e91d771.svg";
export { ForwardRef as ReactComponent };